import {
    USER_SUBMIT_FRUI_PFBZ_BEGIN,
    USER_SUBMIT_FRUI_PFBZ_SUCCESS,
    USER_SUBMIT_FRUI_PFBZ_FAILURE,
    USER_SUBMIT_FRUI_PFBZ_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFrui_pfbz(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_SUBMIT_FRUI_PFBZ_BEGIN,
      });

    const promise = new Promise((resolve, reject) => {
        request({
          method:params.id !== undefined ? 'put' : 'post',
          url:"/api/basic/standard",
          data: params,
        }).then( data => {
            dispatch({
                type: USER_SUBMIT_FRUI_PFBZ_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: USER_SUBMIT_FRUI_PFBZ_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFrui_pfbzError() {
    return {
      type: USER_SUBMIT_FRUI_PFBZ_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_SUBMIT_FRUI_PFBZ_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFrui_pfbzPending: true,
          submitFrui_pfbzError: null,
        };
  
      case USER_SUBMIT_FRUI_PFBZ_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFrui_pfbzPending: false,
          submitFrui_pfbzError: null,
        };
  
      case USER_SUBMIT_FRUI_PFBZ_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFrui_pfbzPending: false,
          submitFrui_pfbzError: action.data.error,
        };
  
      case USER_SUBMIT_FRUI_PFBZ_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFrui_pfbzError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/user/redux/submitFrui_pfbz.js